import { AddOns, ID, Licenses } from "@nova/constants"
import { createSelector } from "@reduxjs/toolkit"
import { RootState } from "integrations/redux"
import { LicenseModalContext, LicensePaywallType } from "./types"
import { AddOn, License } from "@nova/schemas"

const root = (state: RootState) => state.licenses

export const selectAllLicenses = (state: RootState): Record<string, License> =>
    root(state).licensesById

export const selectAllAddOns = (state: RootState): Record<string, AddOn> => root(state).addOnsById

export const selectLicenseById = (licenseId: ID) => (state: RootState) =>
    root(state).licensesById[licenseId] as License | undefined

export const selectAddOnsById = (licenseId: ID) => (state: RootState) =>
    root(state).addOnsById[licenseId] as AddOn | undefined

export const selectSubscriptionModalContext = () => (state: RootState) =>
    root(state).subscriptionModalContext as LicenseModalContext

export const selectAddOnPaywallType = () => (state: RootState) =>
    root(state).addOnPaywallType as AddOns
export const selectLicensePaywallType = () => (state: RootState) =>
    root(state).licensePaywallType as LicensePaywallType

export const selectLicenseUpgrade = () => (state: RootState) =>
    root(state).upgradeLicense as License

export const selectUnassignedLicenses = createSelector([selectAllLicenses], (licenses) => {
    return Object.values(licenses).filter((license) => !license.assigneeId) as License[]
})

export const selectUnassignedAddOns = createSelector([selectAllAddOns], (addOns) => {
    return Object.values(addOns).filter((addOn) => !addOn.assigneeId) as AddOn[]
})

export const selectAvailableLicenseCounts = createSelector(
    [selectUnassignedLicenses],
    (unassignedLicenses) => {
        const counts: Record<Licenses, number> = { lite: 0, essentials: 0, pro: 0 }
        unassignedLicenses.forEach((license) => {
            const type = license.subscriptionType as Licenses
            const currentCount = counts[type]
            counts[type] = currentCount + 1
        })
        return counts
    }
)

export const selectAvailableAddOnsCounts = createSelector(
    [selectUnassignedAddOns],
    (unassignedAddOns) => {
        const counts: Record<AddOns, number> = { hotspots: 0, liveVideo: 0, colorfinder: 0 }
        unassignedAddOns.forEach((addOns) => {
            const type = addOns.subscriptionType as AddOns
            const currentCount = counts[type]
            counts[type] = currentCount + 1
        })
        return counts
    }
)
